var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":"M1907.61,548.99L1902,549v-2l4.52,0.006-5.52-5.475,1.5-1.531,5.51,5.487v-4.493H1910v8h-2.39ZM1909,539h1v-9h-9v1h8v8Zm-9,9v1l-6.69-.01h-2.3v-2.3L1891,540h1v8h8Zm-1.47-9-5.54-5.46L1893,538h-2l0.01-5.615V530H1899v2l-4.49-.006,5.49,5.537Z","transform":"translate(-1891 -530)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }